import { render, staticRenderFns } from "./responsiblePersonsMainView.vue?vue&type=template&id=8bc28d32&scoped=true"
import script from "./responsiblePersonsMainView.vue?vue&type=script&lang=js"
export * from "./responsiblePersonsMainView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc28d32",
  null
  
)

export default component.exports